<template>
    <IndexModelLayout
        :createRoute="$route('admin::signatures.create')"
        :modelNamePlural="__('admin::signatures.signatures')"
    >

        <Table
            :headings="[
                __('admin::labels.name'),
                __('admin::labels.template'),
                __('admin::labels.priority'),
                __('admin::labels.is_active'),
            ]"
            :paginator="paginator"
            @filter="submit"
        >

            <template #filters>
                <Input :placeholder="__('admin::forms.search')" v-model="filter.search" variant="filter" />
            </template>

            <template #results>
                <tr v-for="signature in paginator.data" :key="signature.id">
                    <td>{{ signature.name }}</td>
                    <td>{{ templateOptions[signature.template] || '—' }}</td>
                    <td>{{ signature.priority }}</td>
                    <td>{{ signature.is_active ? __('admin::labels.yes') : __('admin::labels.no') }}</td>
                    <td>
                        <TableButton
                            variant="edit"
                            :href="$route('admin::signatures.edit', { signature: signature.id })"
                        />
                        <TableButton
                            variant="destroy"
                            @delete="deleting = $route('admin::signatures.destroy', { signature: signature.id })"
                        />
                    </td>
                </tr>
            </template>

        </Table>

        <DeleteDialog
            :title="__('admin::general.delete_model', { model: __('admin::signatures.signature') })"
            :url="deleting"
            v-if="deleting"
            @closed="deleting = null"
        />

    </IndexModelLayout>
</template>

<script>
    export default {
        props: {
            paginator: Object,
            request: Object,
            templateOptions: Object,
        },
        data() {
            return {
                filter: this.$inertia.form({
                    search: this.request.search,
                }),
                deleting: null,
            }
        },
        methods: {
            submit() {
                this.filter.get(this.$route('admin::signatures.index'));
            },
        },
    }
</script>
